import { createSlice, nanoid, PayloadAction } from '@reduxjs/toolkit'
import { produce } from 'immer'

import { NotificationsState, NotificationStateItem } from '../model'

const initialState: NotificationsState = {
  notification: undefined,
  notificationsQueue: [],
}

const slice = createSlice({
  initialState,
  name: 'notifications',
  reducers: {
    addNotification(
      state: NotificationsState,
      action: PayloadAction<Omit<NotificationStateItem, 'id'>>
    ) {
      return produce(state, (draft) => {
        draft.notification = { ...action.payload, id: nanoid() }
      })
    },
    addNotificationToQueue: {
      prepare: (data: Omit<NotificationStateItem, 'id'>) => {
        return { payload: { ...data, id: nanoid() } }
      },
      reducer: (state: NotificationsState, action: PayloadAction<NotificationStateItem>) => {
        return produce(state, () => {
          state.notificationsQueue.push(action.payload)
        })
      },
    },
    deleteNotification(state: NotificationsState) {
      return produce(state, (draft) => {
        draft.notification = undefined
      })
    },
    removeNotificationFromQueue(state: NotificationsState, action: PayloadAction<string>) {
      return produce(state, (draft) => {
        draft.notificationsQueue = state.notificationsQueue.filter(
          (notification) => notification.id !== action.payload
        )
      })
    },
  },
})

export const {
  addNotification,
  addNotificationToQueue,
  deleteNotification,
  removeNotificationFromQueue,
} = slice.actions
export const reducer = slice.reducer
